import { jsxs as c, jsx as r } from "react/jsx-runtime";
import { useState as d, cloneElement as m } from "react";
import { tv as p } from "tailwind-variants";
const u = p({
  base: ["bg-white", "border", "border-neutral-200", "rounded-lg"]
}), k = ({ children: s, className: t, heading: n, isOpen: o }) => {
  const [e, l] = d(o), a = (i) => {
    i.preventDefault(), l(!e);
  };
  return /* @__PURE__ */ c("details", { className: u({ class: t }), open: e, children: [
    /* @__PURE__ */ r(
      "summary",
      {
        className: "cursor-pointer list-none [&::-webkit-details-marker]:hidden",
        onClick: a,
        children: m(n, { isOpen: e })
      }
    ),
    /* @__PURE__ */ r("div", { className: "border-t border-neutral-200", children: s })
  ] });
};
export {
  k as default
};
